import Grid from "@material-ui/core/Grid";
import {Typography} from "@material-ui/core";
import QuantityButton from "../QuantitiyButton";
import React from "react";
import {connect} from "react-redux";
import Divider from "../Divider";
import i18n from "../../../i18nextInitiator";
import {decreaseWalking, increaseWalking} from "../../../actions/actionCreators";

const t = i18n.getFixedT('fa', 'general');
const mapStateToProps = state => ({...state.order});

const Walking = (props) => {
    const {
        order: {
            origin_walking: walking
        } = {}
    } = props

    return <>
        <Divider/>
        <Grid container justifyContent={"space-between"}>
            <Grid item xs={"8"} style={{margin: "auto 0"}}>
                <Typography>{t('walking')}</Typography>
                <Typography variant={"subtitle2"}>{t('walking-subtitle')}</Typography>
            </Grid>
            <Grid item xs={"4"} style={{textAlign: "end"}}>
                <QuantityButton value={walking} add={increaseWalking} remove={decreaseWalking}/>
            </Grid>
        </Grid>
    </>
}
export default connect(mapStateToProps)(Walking)